<div class="flex w-full flex-col gap-1 sm:flex-row sm:items-center sm:gap-2" [ngClass]="rowClass">
  <div class="h-[12px] w-full overflow-hidden rounded-full bg-neutral-100" [ngClass]="trackWidthClass">
    <!-- Nothing rendered at 0, so an empty bar never shows a coloured sliver. -->
    @if (value > 0) {
      <div class="h-full rounded-full transition-[width] duration-200" [ngClass]="fillColorClass" [style.width.%]="value"></div>
    }
  </div>

  <span class="shrink-0 whitespace-nowrap text-neutral-500" [ngClass]="labelClass">{{ value }}%</span>
</div>
